import { useEffect } from "react";

export function useSEO({ title, description, ogTitle, ogDescription, ogImage }) {
  useEffect(() => {
    // 1. Update Title
    const formattedTitle = title ? `${title} | Supply Spot` : "Supply Spot // Next-Gen Supply Chain Platform";
    document.title = formattedTitle;

    // Helper to select or create meta tags
    const updateMetaTag = (attrName, attrValue, content) => {
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content || "");
    };

    // 2. Update Description
    if (description) {
      updateMetaTag("name", "description", description);
    }

    // 3. Update Open Graph Meta Tags
    updateMetaTag("property", "og:title", ogTitle || title || "Supply Spot");
    if (description || ogDescription) {
      updateMetaTag("property", "og:description", ogDescription || description);
    }
    if (ogImage) {
      updateMetaTag("property", "og:image", ogImage);
    }

    // 4. Update Twitter Card Meta Tags
    updateMetaTag("property", "twitter:title", ogTitle || title || "Supply Spot");
    if (description || ogDescription) {
      updateMetaTag("property", "twitter:description", ogDescription || description);
    }
    if (ogImage) {
      updateMetaTag("property", "twitter:image", ogImage);
    }
  }, [title, description, ogTitle, ogDescription, ogImage]);
}
